// Helper to get the correct home route based on user role
import type { EMTProfile, EmployerProfile } from '../types/firestore';

type Profile = EMTProfile | EmployerProfile | null;

/**
 * Returns the appropriate home route for a user based on their role and onboarding status.
 * This is the single source of truth for logo/nav clicks.
 */
export function getHomeRoute(profile: Profile | undefined | null): string {
  if (!profile) {
    return '/'; // Not logged in -> landing page
  }

  const role = profile.role;

  if (role === 'employer') {
    const employerCompleted = 
      (profile as EmployerProfile)?.orgId || 
      (profile as any)?.onboarding?.employer?.completed === true;
    
    return employerCompleted ? '/employer/dashboard' : '/employer-registration';
  }

  if (role === 'institute') {
    return '/institute/dashboard';
  }

  if (role === 'emt') {
    const emtCompleted = (profile as any)?.onboarding?.emt?.completed === true;

    // Step 1 creates a usable account (completed=true). Anything short of that — including a
    // legacy half-registered profile — restarts at step 1, which is where location now lives.
    if (!emtCompleted) {
      return '/register/step1';
    }
    
    return '/dashboard';
  }

  // Unknown role -> landing page
  return '/';
}
